const icon = (name) => `Images/Skill-Icons/${name}.svg`;

export const LanguagesAndDatabases = [
  { name: "JavaScript", img: icon("js") },
  { name: "TypeScript", img: icon("typescript") },
  { name: "C++", img: icon("cpp") },
  { name: "HTML", img: icon("html") },
  { name: "CSS", img: icon("css") },
  { name: "MySQL", img: icon("mysql") },
  { name: "Postgres", img: icon("postgres") },
  { name: "MongoDB", img: icon("mongo") },
];

export const Frontend = [
  { name: "Next.js", img: icon("next") },
  { name: "React.js", img: icon("react") },
  { name: "React Native", img: icon("react-native") },
  { name: "React Query", img: icon("react-query") },
  { name: "React Remix", img: icon("remix") },
  { name: "Redux", img: icon("redux") },
  { name: "Zustand", img: icon("zustand") },
  { name: "Tailwind", img: icon("tailwind") },
  { name: "SCSS", img: icon("sass") },
  { name: "Shadcn UI", img: icon("shadcn") },
  { name: "Material UI", img: icon("material-ui") },
];

export const Backend = [
  { name: "NestJS", img: icon("nestjs") },
  { name: "Node.js", img: icon("node") },
  { name: "Express.js", img: icon("express") },
  { name: "Kafka", img: icon("kafka") },
  { name: "Redis", img: icon("redis") },
  { name: "BullMQ", img: icon("bullmq") },
  { name: "TypeORM", img: icon("typeorm") },
  { name: "GraphQL", img: icon("graphql") },
  { name: "REST APIs", img: icon("rest-api") },
];

export const ToolsAndOther = [
  { name: "AI Automation", img: icon("n8n") },
  { name: "GCP", img: icon("gcp") },
  { name: "Git", img: icon("git") },
  { name: "Bitbucket", img: icon("bitbucket") },
  { name: "Postman", img: icon("postman") },
  { name: "Operating Systems", img: icon("os") },
  { name: "DBMS", img: icon("dbms") },
  { name: "OOP", img: icon("oop") },
];

export const sections = [
  {
    title: "Languages & Databases",
    data: LanguagesAndDatabases,
    accent: "#3f91f9",
  },
  {
    title: "Frontend",
    data: Frontend,
    accent: "#f7cb45",
  },
  {
    title: "Backend",
    data: Backend,
    accent: "#F8615C",
  },
  {
    title: "Tools & Other",
    data: ToolsAndOther,
    accent: "#9b59b6",
  },
];
